<template>
  <div id="price">
    <div class="container-fluid" v-if="data.length">
      <div class="productwrap">
        <h4 class="cust-head" style="margin-top: 9px;color:#533a79!important;text-transform:capitalize;"> {{ data[0].product }} </h4>
        <b-row style="justify-content: center">
          <b-col sm="3" lg="3" v-for="d in data" :key="d.platform">
            <b-card style="border:none;" :class="d.platform + '_border'">
              <div class="leftsticker"  :class="d.platform + '_bg'">
                {{ d.platform.slice(0,1).toUpperCase()  }}
              </div> 
              <div class="rightsticker">
                <div class="name">
                  <a target="_blank" :href="d.product_link">{{ d.platform }} </a></div>
                <div class="value" :class="d.platform + '_color'">
                  <i class="fa fa-rupee" v-if="d.price!='N/A'" ></i> 
                  {{ d.price }}
                  <span v-if="d.quantity"> ({{ d.quantity }})</span>
                  <div class="outofstock" v-if="d.out_of_stock">Out of stock</div>
                </div>
              </div>  
            </b-card>
          </b-col>
          <b-col sm="3" lg="3" >
            <b-card style="border:none;border-right: 2px solid #533a79;">
              <div class="leftsticker" style="background:#533a79;">
                <i class="fa fa-clock-o"></i>
              </div> 
              <div class="rightsticker">
                <div class="name">Last updated on</div>
                <div class="value" style="color:#533a79;">{{ moment(data[0].timestamp).format('DD MMM YYYY HH:mm') }} </div>
              </div>  
            </b-card>
          </b-col>
        </b-row>  
      </div>  
    </div>
  </div>
</template>

<script> 
import moment from 'moment'
import datecomponent from './date.vue'

export default {
  name: 'price',
  components: {
    datecomponent
  },
  data: function () {
    return {
      data: [],
      moment:moment
    }
  },
  mounted()
  {
    this.refresh()
  },
  methods: {
    refresh(){
      let url = "/api/reviews/recentprice"
      this.$http.get(url).then(response => {
        this.data = response.data.data  
        console.log(this.data) 
      }, err => {
        console.log('error')
      });
    },
  }
}
</script>
<style scoped>
 .name
 {
    line-height: 28px;
    text-transform: capitalize;
    font-size: 19px;
    margin-left: 10px;
 }
 .value
 {
    font-size: 16px;
    line-height: 24px;
    margin-left: 11px;
 }
 .leftsticker
 {
    width: 100px;
    float: left;
    height: 54px;
    color: white;
    font-size: 37px;
    text-align: center;
 }
 .rightsticker
 {
    width: 300px;
    float: left;
    background:#f7f7f7;
 }
 .card-body
 {
  padding:0!important;
  display:flex;
 }
 .productwrap
 {
    background: white;
    padding: 6px;
    margin-top: 6px;
 }
 .grofers_color
 {
  color:#f15c2c;
 }
 .grofers_border
 {
  border-right: 2px solid #f15c2c!important;
 }
 .grofers_bg
 {
    background: url(/img/grofers.png)!important;
    background-repeat: round!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 }
  .bigbasket_color
 {
  color:#83c42a;
 }
 .bigbasket_border
 {
   border-right: 2px solid #83c42a!important;
 }
 .bigbasket_bg
 {
    background: url(/img/bbasket.png)!important;
    background-repeat: round!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 } 
 .amazon_bg
 {
    background: url(/img/amazon.png)!important;
    background-repeat: no-repeat!important;
    background-position: center!important;
    border: 1px solid #f7f7f7;
    color: transparent!important;
 } 
 .amazon_border
 {
  border-right: 2px solid #FF9900!important;
 }
  .amazon_color
 {
  color:#FF9900!important;
 }
 .outofstock
 {
    color:red;
    float:right;
    font-size:12px;
    margin-right:6px
 }
</style>